<template>
    <div class="checkbox-group">
      <label v-for="option in options" :key="option" class="checkbox-label">
        <input
          type="checkbox"
          :value="option"
          v-model="selectedOptions"
          @change="onChange"
        >
        {{ option }}
      </label>
    </div>
  </template>

<script>
export default {
  name: 'CheckboxInput',
  props: ['value', 'options'],
  data() {
    return {
      selectedOptions: this.value || []
    }
  },
  methods: {
    onChange() {
      this.$emit('input', this.selectedOptions)
    }
  }
}
</script>
